export const BUSINESS_NAME = "Meester Stoffeerders";
export const BUSINESS_PHONE = "+31 6 81677899";
export const BUSINESS_EMAIL = "info@meesterstoffeerders.nl";
export const BUSINESS_ADDRESS = "Argonweg 66, Almere";
export const INSTAGRAM_URL = "https://www.instagram.com/meesterstoffeerders";
export const FACEBOOK_URL = "https://www.facebook.com/MeesterStoffeerders";
export const GOOGLE_REVIEWS_URL =
  "https://www.google.com/maps/search/?api=1&query=Meester+Stoffeerders+Argonweg+66+Almere";
